import { analytics } from '../services/googleAnalytics';

// Track errors with both analytics systems
export const trackError = (error: Error, location: string) => {
  // Track with Google Analytics for debugging
  analytics.trackError(error.message, location);

  // Track with in-house analytics for error monitoring
  // Note: AnalyticsService doesn't have trackError method yet
  // This would need to be implemented in the backend
  console.log('[Analytics] Error tracked:', error.message, location);
};

// Global error handler for unhandled errors
export const setupGlobalErrorHandling = () => {
  // Handle unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const error = new Error(event.reason?.message || 'Unhandled promise rejection');
    trackError(error, 'global:unhandledRejection');
  });

  // Handle global errors
  window.addEventListener('error', (event) => {
    trackError(event.error || new Error(event.message), 'global:error');
  });
};

// React Error Boundary helper
export const logErrorToAnalytics = (
  error: Error,
  errorInfo: { componentStack?: string | null }
) => {
  const location = `ErrorBoundary:${errorInfo.componentStack?.split('\n')[1]?.trim() || 'unknown'}`;
  trackError(error, location);
};
